import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokashidbeachcab() {



  const cardData = {
"keyword": "Pune to Kashid Beach Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Kashid Beach Cab for travelers seeking a safe, affordable, and scenic coastal travel experience. Whether you are planning a family beach holiday, romantic getaway, friends’ trip, weekend break, photography tour, or relaxation journey, our taxi service ensures a smooth and stress-free ride to one of Maharashtra’s most beautiful beaches. With experienced drivers who are well-versed with Konkan coastal routes and highway driving, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Kashid Beach. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible one-way and round-trip options, doorstep pickup from Pune, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and refreshing journey to Kashid Beach.",

"topPlaces": [
  {
    "title": "Kashid Beach",
    "description":
      "Kashid Beach is a pristine white sand beach on the Konkan coast known for its clean shoreline, blue waters, and peaceful atmosphere. It is one of the most popular beach destinations near Pune for weekend getaways and relaxation."
  },
  {
    "title": "Murud Janjira Fort",
    "description":
      "Murud Janjira Fort is a powerful sea fort located on an island near Kashid, famous for its strong architecture, undefeated history, and scenic boat rides to reach the fort."
  },
  {
    "title": "Phansad Wildlife Sanctuary",
    "description":
      "Phansad Wildlife Sanctuary near Kashid is rich in biodiversity, home to dense forests, birds, and wildlife, making it ideal for nature lovers and eco-tourism visitors."
  },
  {
    "title": "Nandgaon Beach",
    "description":
      "Nandgaon Beach is a peaceful and less crowded beach near Kashid known for its clean sands, coconut trees, and serene coastal environment."
  },
  {
    "title": "Revdanda Fort",
    "description":
      "Revdanda Fort is a coastal fort near Kashid Beach offering historical ruins, sea views, and a glimpse into the region’s Portuguese and Maratha history."
  },
  {
    "title": "Alibaug Coastal Belt",
    "description":
      "The Alibaug coastal region near Kashid is famous for multiple beaches, forts, and resorts, making it a popular extension for weekend travelers from Pune."
  },
  {
    "title": "Korlai Fort",
    "description":
      "Korlai Fort is a historic Portuguese fort near Kashid offering panoramic sea views, lighthouse scenery, and trekking opportunities."
  },
  {
    "title": "Murud Town",
    "description":
      "Murud is a small coastal town near Kashid known for local markets, seafood, and its proximity to Janjira Fort and surrounding beaches."
  },
  {
    "title": "Konkan Coastal Drive",
    "description":
      "The Pune to Kashid route passes through scenic Konkan roads, green hills, coastal stretches, and small villages, making the journey itself highly enjoyable and picturesque."
  },
  {
    "title": "Dighi Port Region",
    "description":
      "The nearby Dighi Port region is an important coastal industrial and maritime area contributing to the economic significance of the Raigad coastline."
  }
],



services: [
  {
    name: "Pune to Kashid Beach Cab",
    description: "Pune to Kashid Beach cab service provides reliable transportation for passengers traveling between Pune and Kashid Beach with comfortable vehicles and experienced drivers. Vehicles are suitable for long-distance coastal highway travel ensuring smooth and timely journeys for families, tourists, beach travelers, and local passengers. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient Pune to Kashid Beach cab reservations."
  },
  {
    name: "Pune to Kashid Taxi",
    description: "Pune to Kashid taxi service offers dependable transportation for beach and Konkan outstation travel with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for beach holidays, family travel, tourism, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Pune to Kashid taxi reservations."
  },
  {
    name: "Cab from Pune to Kashid Beach",
    description: "Cab from Pune to Kashid Beach service provides comfortable transportation for passengers traveling from Pune to Kashid and nearby coastal destinations. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth travel journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and nearby locations across Pune. Ideal for tourists, families, and beach holiday travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Kashid Beach",
    description: "Taxi from Pune to Kashid Beach service offers reliable transportation with comfortable vehicles and professional drivers for passengers requiring direct travel between Pune and Kashid Beach. Vehicles provide smooth city and highway travel suitable for tourism, beach vacations, weekend outings, and family travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available directly from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Kashid Beach Cab Service",
    description: "Pune to Kashid Beach cab service provides dependable transportation solutions for outstation travel between Pune and Kashid Beach. Vehicles are suitable for long-distance travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for beach holidays, tourism trips, Konkan tours, and family vacations. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Pune to Kashid Beach Taxi Fare",
    description: "Pune to Kashid Beach taxi fare service provides transparent and reliable transportation options for travelers planning budget-friendly travel between Pune and Kashid Beach. Travelers can enjoy smooth journeys with experienced drivers familiar with coastal routes and ghat road conditions. Comfortable vehicles ensure timely travel with safe transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient taxi fare cab reservations."
  },
  {
    name: "Pune to Kashid Beach One Way Cab",
    description: "Pune to Kashid Beach one way cab service provides economical and comfortable transportation for travelers planning one-side travel between Pune and Kashid Beach. Comfortable vehicles ensure smooth highway travel suitable for tourism, beach holidays, weekend trips, and family travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Kashid Beach Round Trip Taxi",
    description: "Pune to Kashid Beach round trip taxi service offers spacious transportation for families and groups traveling between Pune and Kashid Beach with return travel options. Vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for family outings and Konkan beach travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient round trip taxi reservations."
  },
  {
    name: "Pune to Kashid Beach Cab Booking",
    description: "Pune to Kashid Beach cab booking service provides premium transportation for passengers seeking comfortable and reliable beach destination travel. Vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, beach vacations, and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Cheap Pune to Kashid Beach Cab",
    description: "Cheap Pune to Kashid Beach cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Kashid Beach. Vehicles provide smooth highway travel with comfortable seating and luggage space suitable for one-way and round-trip journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Kashid Beach Taxi",
    description: "Best Pune to Kashid Beach taxi service offers dependable transportation for passengers planning direct outstation travel between Pune and Kashid Beach. Comfortable vehicles ensure smooth highway travel suitable for tourism, beach holidays, weekend travel, and family trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Kashid Beach Cab",
    description: "Sedan Pune to Kashid Beach cab service provides reliable transportation for travelers planning long-distance journeys between Pune and Kashid Beach. Sedan vehicles ensure smooth and safe travel suitable for tourists, couples, families, and vacation travelers. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Kashid Beach Taxi",
    description: "SUV Pune to Kashid Beach taxi service offers comfortable transportation for passengers looking for spacious and reliable travel services between Pune and Kashid Beach. SUV vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for beach holidays, family tours, Konkan travel, and outstation travel requirements. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Kashid Beach Cab",
    description: "Innova Pune to Kashid Beach cab service provides dependable transportation for passengers planning premium outstation travel between Pune and Kashid Beach. Innova vehicles ensure smooth highway travel suitable for tourism, Konkan tours, beach vacations, and family holidays. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Beach Trip Cab Pune Kashid",
    description: "Beach trip cab Pune Kashid service provides affordable and convenient transportation for passengers traveling between Pune and Kashid Beach through scenic coastal routes. Vehicles ensure reliable highway travel with experienced drivers offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for tourists, beach travelers, Konkan holiday trips, and family vacation travel requirements. Flexible booking options allow convenient beach trip cab reservations."
  }
],

tableData: [
  ["Pune to Kashid Beach Cab", "Pune to Kashid Taxi"],
  ["Cab from Pune to Kashid Beach", "Taxi from Pune to Kashid Beach"],
  ["Pune to Kashid Beach Cab Service", "Pune to Kashid Beach Taxi Fare"],
  ["Pune to Kashid Beach One Way Cab", "Pune to Kashid Beach Round Trip Taxi"],
  ["Pune to Kashid Beach Cab Booking", "Cheap Pune to Kashid Beach Cab"],
  ["Best Pune to Kashid Beach Taxi", "Sedan Pune to Kashid Beach Cab"],
  ["SUV Pune to Kashid Beach Taxi", "Innova Pune to Kashid Beach Cab"],
  ["Beach Trip Cab Pune Kashid", "Pune to Kashid Beach Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Kashid Beach Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Kashid Beach cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe coastal travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Kashid Beach Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Kashid Beach cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Kashid Beach Cab Availability",
        WhyChoosedescription: "Our Pune to Kashid Beach cab service operates 24 hours a day for beach vacations, family tours, weekend getaways, Konkan travel, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers visiting Kashid Beach."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Kashid Beach taxi service, round-trip bookings, beach sightseeing tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for couples, families, tourists, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Coastal Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Kashid Beach highway and coastal routes, ensuring safe driving, smooth travel, and timely arrival for every beach journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Kashid Beach cab service?", answer: "Pune to Kashid Beach cab service provides comfortable taxi transportation between Pune and Kashid Beach for beach holidays, Konkan travel, and family trips." },
    { question: "Is Pune to Kashid Beach cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Kashid Beach cab service." },
    { question: "Which vehicles are available for Pune to Kashid Beach travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Kashid Beach?", answer: "Yes, customers can book one-way as well as round-trip Pune to Kashid Beach taxi services." },
    { question: "Do you provide Kashid Beach sightseeing taxi packages?", answer: "Yes, Shivai Travels provides Kashid Beach sightseeing and customized Konkan travel packages." },
    { question: "Are all Pune to Kashid Beach taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Kashid Beach cab service online?", answer: "Yes, customers can easily book Pune to Kashid Beach cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune to Kashid Beach cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Kashid Beach cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Deshmukh",
    feedback:
      "Had a pleasant Pune to Kashid Beach cab journey with a comfortable vehicle and a professional driver who ensured a smooth and enjoyable coastal travel experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Jadhav",
    feedback:
      "The Pune to Kashid Beach taxi service was very reliable with timely pickup, clean car, and a relaxed ride making our beach trip truly enjoyable.",
    rating: 5
  }
];




  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Kashid Beach Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-kashid-beach-cab.jpg",
  "description": "Book Pune to Kashid Beach Cab Service for safe and comfortable beach travel. Shivai Travels offers reliable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7 for coastal and weekend trips.",
  "brand": {
    "@type": "Brand",
    "name": "Shivaitravels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-kashid-beach-cab"
  }
};





  return (
    <div>

<Helmet>
  <title>Pune to Kashid Beach Cab Service | Beach Trip Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Kashid Beach cab service for safe and comfortable beach travel. Affordable one-way and round-trip taxi options with sedan, SUV, Innova, and luxury cabs available 24x7."
  />

  <meta
    name="keywords"
    content="pune to kashid beach cab, pune to kashid taxi, cab from pune to kashid beach, taxi from pune to kashid beach, pune to kashid beach cab service, pune to kashid beach taxi fare, pune to kashid beach one way cab, pune to kashid beach round trip taxi, pune to kashid beach cab booking, cheap pune to kashid beach cab, best pune to kashid beach taxi, sedan pune to kashid beach cab, suv pune to kashid beach taxi, innova pune to kashid beach cab, beach trip cab pune kashid"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/75.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokashidbeachcab;